export type RaffleStore = {
  id: string
  city: string
  name: string
  address: string
}

export const FC_STORES: Record<string, RaffleStore> = {
  'New York': {
    id: 'fc-nyc',
    city: 'New York',
    name: 'Flight Club New York',
    address: '812 Broadway New York, NY 10003',
  },
  'Los Angeles': {
    id: 'fc-la',
    city: 'Los Angeles',
    name: 'Flight Club Los Angeles',
    address: '535 N Fairfax Ave, Los Angeles, CA 90036',
  },
  'Miami': {
    id: 'fc-mia',
    city: 'Miami',
    name: 'Flight Club Miami',
    address: '3910 NE 1st Ave, Miami, FL 33137',
  },
  'Tokyo': {
    id: 'fc-tokyo',
    city: 'Tokyo',
    name: 'Flight Club Tokyo',
    address: '3-21-7 Jingumae, Shibuya-Ku, Tokyo 150-0001',
  },
}
